import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TextEditorComponent} from "../text-editor/text-editor.component";
import {Subject} from "rxjs";

@Component({
  selector: 'app-modal-text-editor',
  templateUrl: './modal-text-editor.component.html',
  styleUrls: ['./modal-text-editor.component.css']
})
export class ModalTextEditorComponent implements OnInit {

  @ViewChild(TextEditorComponent) editor: TextEditorComponent;

  id: string;

  public showSaveButton = true;
  public showSaveWithNameButton = true;

  public modalTitle = '';
  public textCloseButton = 'Esci senza salvare';

  public saveSubscription$ = new Subject();
  public saveWithNameSubscription$ = new Subject();
  public closeSubscription$ = new Subject();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  hideSaveButton() {
    this.showSaveButton = false;
  }

  hideSaveWithNameButton() {
    this.showSaveWithNameButton = false;
  }

  changeTextCloseButton(text: string) {
    this.textCloseButton = text;
  }

  setTitle(title: string) {
    this.modalTitle = title;
  }

  setId(id: string) {
    this.id = id;
  }

  getId() {
    return this.id;
  }

  getEditor(): TextEditorComponent {
    return this.editor;
  }

  saveAction() {
    const text = this.editor.getText();
    this.saveSubscription$.next({id: this.id, nota: text});
    this.close();
  }

  saveWithNameAction() {
    const text = this.editor.getText();
    this.saveWithNameSubscription$.next({id: this.id, nota: text});
    this.close();
  }

  closeAction() {
    const text = this.editor.getText();
    this.closeSubscription$.next({id: this.id, nota: text});
    this.close();
  }

  close() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-text-editor/modal-text-editor.component.ts